module.exports = __webpack_public_path__ + "static/media/bandeau_expertise_mav.801d4730.jpg";